import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    width: '100%',
  },
  boxTitle: {
    fontSize: 20,
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
  boxCheck: {
    fontSize: 20,
    fontWeight: 500,
  },
  modal: {
    //marginTop: theme.spacing(10),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
  },
  notify: {
    '& .MuiTypography-body1 ': {
      fontSize: '14px',
    },
  },
  paper: {
    backgroundColor: '#ffffff',
    padding: theme.spacing(3),
    boxShadow: theme.shadows[0],
    width: 'calc(50% - 12px)',
    marginBottom: theme.spacing(2),
  },
  rowWide: {
    position: 'relative',

    marginBottom: theme.spacing(3.5),
  },
  row: {
    position: 'relative',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(3.5),
  },
  title: {
    margin: theme.spacing(0, 3.5, 0, 0),
    fontSize: 14,
    letterSpacing: 0.15,
    color: 'rgb(0 0 0 / 54%)',
  },
  input: {
    width: '100%',
    color: 'rgb(0 0 0 / 87%)',
    // '&:before': {
    //   borderBottom: '1px solid #E0E0E0',
    // },
    '& .MuiInputBase-input': {
      padding: '18px 0 6px',
    },
    '& label': {
      transform: 'translate(0, 0)',
      '& + div': {
        margin: 0,
      },
    },
  },
  inputTwo: {
    color: 'rgb(0 0 0 / 87%)',
    width: '90%',
    '& .MuiInputBase-input': {
      padding: '18px 6px',
    },
    '& label': {
      transform: 'translate(0, 0)',
      '& + div': {
        margin: 0,
      },
    },
    '& .MuiPhoneNumber-flagButton': {
      marginTop: '15px',
    },
  },
  inputphone: {
    color: 'rgb(0 0 0 / 87%)',
    width: '90%',
    '& .MuiInputBase-input': {
      paddingTop: '24px',
    },
    '& label': {
      transform: 'translate(0, 0)',
      '& + div': {
        margin: 0,
      },
    },
    '& .MuiPhoneNumber-flagButton': {
      marginTop: '15px',
    },
  },
  inputError: {
    width: '100%',
    color: 'rgb(0 0 0 / 87%)',
    marginBottom: theme.spacing(-2.8),
    '& .MuiInputBase-input': {
      padding: '18px 0 6px',
    },
    // '&:before': {
    //   borderBottom: '1px solid #E0E0E0',
    // },
    '& label': {
      transform: 'translate(0, 0)',
      '& + div': {
        margin: 0,
      },
    },
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  btn: {
    padding: theme.spacing(1, 2),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWide: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
  },
  btnWideLeft: {
    padding: theme.spacing(1, 5),
    fontSize: 14,
    textTransform: 'none',
    marginRight: 10,
  },
  imgBox: {
    width: 136,
    padding: 0,
  },
  fieldsBox: {
    width: 'calc(100% - 140px)',
    paddingLeft: theme.spacing(4),
    paddingRight: 0,
  },
  tableBox: {
    width: '100%',
    padding: 0,
  },
  userImg: {
    width: 136,
    height: 136,
    background: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #5081FF',
    borderRadius: 8,
    marginBottom: theme.spacing(2),
    overflow: 'hidden',
  },
  actionBox: {
    position: 'absolute',
    right: 0,
  },
  halfSizeRow: {
    position: 'relative',
    alignItems: 'center',

    marginBottom: theme.spacing(3.5),
  },
  link: {
    //alignItems: 'flex-grow',
    marginLeft: theme.spacing(7),
    display: 'flex',
    alignItems: 'flex-end',
    color: '#737373',
  },
  radioLabel: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '150%',
    letterSpacing: '0.15px',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  rowRadio: {
    position: 'relative',
    alignItems: 'center',
    marginBottom: '10px',
  },
}));
